export const isDate = (date: unknown) =>
  Object.prototype.toString.call(date) === '[object Date]'

export default isDate
